import Slider from "react-slider";

interface IProps {
  values: number[];
  min: number;
  max: number;
  onChange: (event: any) => void;
}
function MultiRangeSlider(props: IProps) {
  return (
    <div>
      <Slider
        className="slider"
        value={props.values}
        min={props.min}
        max={props.max}
        onChange={props.onChange}
        trackClassName="track"
      ></Slider>
    </div>
  );
}

export default MultiRangeSlider;
